import React, { Fragment } from 'react';
import FormCheckout from 'v2/components/Pages/Product/Edit/Forms/Checkout';
import FormPayment from 'v2/components/Pages/Product/Edit/Forms/Payment';
import FormRecovery from 'v2/components/Pages/Product/Edit/Forms/Recovery';
import Content from 'v2/components/Shared/Content';

import { useEditProduct } from '../../context';
import PaymentValidations from './validations';

function Payment() {
  const {
    paymentType,
    savePaymentType,
    isLoadingPaymentType,

    checkout,
    saveCheckout,
    isLoadingCheckout,

    recovery,
    saveRecovery,
    isLoadingRecovery,
  } = useEditProduct();

  return (
    <Fragment>
      <Content>
        {[
          {
            id: 'payments',
            title: 'Formas de cobrança',
            anchor: 'Formas de cobrança',
            validations: PaymentValidations.paymentsSchema,
            submit: savePaymentType,
            defaultValues: paymentType,
            isLoading: isLoadingPaymentType,
            content: (cProps: any) => <FormPayment {...cProps} />,
          },
          {
            id: 'checkout',
            title: 'Meios de pagamento e checkout',
            anchor: 'Meios de pagamento e checkout',
            validations: PaymentValidations.checkoutSchema,
            submit: saveCheckout,
            isLoading: isLoadingCheckout,
            defaultValues: checkout,
            content: (cProps: any) => <FormCheckout {...cProps} />,
          },
          {
            id: 'recovery',
            title: 'Recuperação de vendas',
            anchor: 'Recuperação de vendas',
            validations: PaymentValidations.recoverySchema,
            submit: saveRecovery,
            isLoading: isLoadingRecovery,
            defaultValues: recovery,
            content: (cProps: any) => <FormRecovery {...cProps} />,
          },
        ]}
      </Content>
    </Fragment>
  );
}

export default Payment;
